import L from 'leaflet'
import Control from './control'
import rulerInfoControler from './ruler-info-controler'
import rulerLegendControler from '../leaflet-legends/ruler-legend'
export default Control.extend({
  _allLayers: null,
  _legend: null,
  id: 'ruler',
  options: {
    position: 'topright'
  },
  onAdd: function (map) {
    map.customControls[this.id] = this
    this._container = L.DomUtil.create('div')
    L.DomEvent.disableClickPropagation(this._container)
    L.DomEvent.on(this._map._container, 'keydown', this._toggleRuler, this)
    L.DomEvent.on(this._map._container, 'keyup', this._toggleRuler, this)
    this._allLayers = L.layerGroup()
    this._allLayers.addTo(this._map)

    this._legend = new rulerLegendControler({
      vue: this.options.vue,
      defaultColor: this.options.defaultColor,
      parent: this
    })
    this._legend.addTo(this._map)
    map.on('change-map', this._newConfigValues, this)
    map.on('change-type', this._newConfigValues, this)
    return this._container
  },
  _newConfigValues: function () {
    this._allLayers.eachLayer(layer => {
      this._findInfo(layer)
    })
  },
  _toggleRuler: function (event) {
    if (event.shiftKey && event.type === "keydown") {
      this._map._container.classList.add('leaflet-shift')
      this._map.on('click', this._clicked, this);
      this._map.on('mousemove', this._mapMousemoving, this);
    } else if (!event.shiftKey && event.type === "keyup") {
      this._map._container.classList.remove('leaflet-shift')
      this._map.off('click', this._clicked, this);
      this._map.off('mousemove', this._mapMousemoving, this);

      if (this._resizeSquare) {
        this._resizeSquare()
      }
    }
  },
  _createControl: function (segment) {
    const control = new rulerInfoControler({
      id: 'control-for-' + segment._leaflet_id,
      segment,
      vue: this.options.vue,
      defaultColor: this.options.defaultColor,
      inactiveColor: this.options.inactiveColor
    })
    control.addTo(this.options.vue.map)
    segment.options.control = control
  },
  changeCoordinates: function ({ lat, lng }) {
    const [gameX, gameY] = this._map.convertPointToGameCoord(
      {
        x: lng,
        y: lat
      },
      this._map.options.mapConfig
    )
    return { lat: gameY, lng: gameX }
  },
  onRemove: function (map) {
    map.removeControl(this._legend)
    map.removeLayer(this._allLayers)

    if (this._square) {
      map.removeLayer(this._square)
    }

    map.off('change-map', this._newConfigValues, this)
    map.off('change-type', this._newConfigValues, this)
    L.DomEvent.off(this._map._container, 'keydown', this._toggleRuler, this)
    L.DomEvent.off(this._map._container, 'keyup', this._toggleRuler, this)
  }
})
